import { Expression } from 'mapbox-gl'
import { POI_CATEGORIES_MAP } from 'src/constants/poi-categories'
import { MapLayerType } from 'src/types/mapbox-main-map'

export const POI_LAYER_ID: MapLayerType = 'poi-layer'
export const PARCEL_LAYER_ID: MapLayerType = 'parcel-layer'
export const PARCEL_LINE_LAYER_ID: MapLayerType = 'parcel-line-layer'
export const POI_SELECTED_LAYER_ID: MapLayerType = 'poi-selected-layer'
export const BORDER_FILL_LAYER_ID: MapLayerType = 'borders-fill-layer'
export const BORDER_LINE_LAYER_ID: MapLayerType = 'borders-line-layer'
export const HEATMAP_FILL_LAYER_ID: MapLayerType = 'heatmap-fill-layer'
export const HEATMAP_LINE_LAYER_ID: MapLayerType = 'heatmap-line-layer'
export const POI_SELECTED_SOURCE_ID = 'poi-selected-source'
export const POI_SOURCE_HOVERED_ID = 'poi-hovered-source'
export const POI_HOVERED_LAYER_ID = 'poi-hovered-layer'
export const LOCATION_PARCEL_SOURCE_ID = 'location-parcel-source'
export const LOCATION_PARCEL_FILL_LAYER_ID = 'location-parcel-fill-layer'
export const LOCATION_PARCEL_LINE_LAYER_ID = 'location-parcel-line-layer'
export const GOOGLE_RESULTS_SOURCE_ID = 'google-results-source'
export const GOOGLE_RESULTS_HOVERED_SOURCE_ID = 'google-results-hovered-source'
export const GOOGLE_RESULTS_LAYER_ID = 'google-results-layer'
export const GOOGLE_RESULTS_HOVERED_LAYER_ID = 'google-results-hovered-layer'

// user list
export const USER_LIST_LOCATION_SOURCE_ID = 'user-lists-locations-source'
export const USER_LIST_LOCATION_LAYER_ID = 'user-lists-locations-layer'
export const USER_LIST_RADIUS_RINGS_SOURCE_ID = 'user-lists-radius-rings-source'
export const USER_LIST_RADIUS_RINGS_LAYER_ID = 'user-lists-radius-rings-layer'
export const USER_LIST_RADIUS_RINGS_LINE_LAYER_ID = 'user-lists-radius-rings-line-layer'

export const CAROUSEL_CARD_HEIGHT = 286
export const CAROUSEL_ICON_SIZE = 18

export const LIST_TYPE = 'list'
export const TABLE_TYPE = 'table'

export const EMPTY_MAP_DATA_SOURCE: GeoJSON.FeatureCollection<GeoJSON.Geometry> = {
  type: 'FeatureCollection',
  features: [],
}

// Category pins
export const RETAIL_PIN_LIGHT = 'pin-retail-light'
export const RETAIL_PIN_DARK = 'pin-retail-dark'
export const RETAIL_PIN_ALT_LIGHT = 'pin-retail-alt-light'
export const RETAIL_PIN_ALT_DARK = 'pin-retail-alt-dark'
export const RETAIL_SELECTED_PIN_LIGHT = 'pin-retail-selected-light'
export const RETAIL_SELECTED_PIN_DARK = 'pin-retail-selected-dark'
export const MEDICAL_PIN_LIGHT = 'pin-medical-light'
export const MEDICAL_PIN_DARK = 'pin-medical-dark'
export const MEDICAL_PIN_ALT_LIGHT = 'pin-medical-alt-light'
export const MEDICAL_PIN_ALT_DARK = 'pin-medical-alt-dark'
export const MEDICAL_SELECTED_PIN_LIGHT = 'pin-medical-selected-light'
export const MEDICAL_SELECTED_PIN_DARK = 'pin-medical-selected-dark'
export const OFFICE_PIN_LIGHT = 'pin-office-light'
export const OFFICE_PIN_DARK = 'pin-office-dark'
export const OFFICE_PIN_ALT_LIGHT = 'pin-office-alt-light'
export const OFFICE_PIN_ALT_DARK = 'pin-office-alt-dark'
export const OFFICE_SELECTED_PIN_LIGHT = 'pin-office-selected-light'
export const OFFICE_SELECTED_PIN_DARK = 'pin-office-selected-dark'
export const INDUSTRIAL_PIN_LIGHT = 'pin-industrial-light'
export const INDUSTRIAL_PIN_DARK = 'pin-industrial-dark'
export const INDUSTRIAL_PIN_ALT_LIGHT = 'pin-industrial-alt-light'
export const INDUSTRIAL_PIN_ALT_DARK = 'pin-industrial-alt-dark'
export const INDUSTRIAL_SELECTED_PIN_LIGHT = 'pin-industrial-selected-light'
export const INDUSTRIAL_SELECTED_PIN_DARK = 'pin-industrial-selected-dark'
export const HOSPITALITY_PIN_LIGHT = 'pin-hospitality-light'
export const HOSPITALITY_PIN_DARK = 'pin-hospitality-dark'
export const HOSPITALITY_PIN_ALT_LIGHT = 'pin-hospitality-alt-light'
export const HOSPITALITY_PIN_ALT_DARK = 'pin-hospitality-alt-dark'
export const HOSPITALITY_SELECTED_PIN_LIGHT = 'pin-hospitality-selected-light'
export const HOSPITALITY_SELECTED_PIN_DARK = 'pin-hospitality-selected-dark'
export const MULTIFAMILY_PIN_LIGHT = 'pin-multi-family-light'
export const MULTIFAMILY_PIN_DARK = 'pin-multi-family-dark'
export const MULTIFAMILY_PIN_ALT_LIGHT = 'pin-multi-family-alt-light'
export const MULTIFAMILY_PIN_ALT_DARK = 'pin-multi-family-alt-dark'
export const MULTIFAMILY_SELECTED_PIN_LIGHT = 'pin-multi-family-selected-light'
export const MULTIFAMILY_SELECTED_PIN_DARK = 'pin-multi-family-selected-dark'
export const SINGLEFAMILY_PIN_LIGHT = 'pin-single-family-light'
export const SINGLEFAMILY_PIN_DARK = 'pin-single-family-dark'
export const SINGLEFAMILY_PIN_ALT_LIGHT = 'pin-single-family-alt-light'
export const SINGLEFAMILY_PIN_ALT_DARK = 'pin-single-family-alt-dark'
export const SINGLEFAMILY_SELECTED_PIN_LIGHT = 'pin-single-family-selected-light'
export const SINGLEFAMILY_SELECTED_PIN_DARK = 'pin-single-family-selected-dark'
export const OTHER_PIN_LIGHT = 'pin-other-light'
export const OTHER_PIN_DARK = 'pin-other-dark'
export const OTHER_PIN_ALT_LIGHT = 'pin-other-alt-light'
export const OTHER_PIN_ALT_DARK = 'pin-other-alt-dark'
export const OTHER_PIN_SELECTED_LIGHT = 'pin-other-selected-light'
export const OTHER_PIN_SELECTED_DARK = 'pin-other-selected-dark'
export const SHOPPING_CENTER_PIN_LIGHT = 'pin-shopping-center-light'
export const SHOPPING_CENTER_PIN_DARK = 'pin-shopping-center-dark'
export const SHOPPING_CENTER_SELECTED_PIN_LIGHT = 'pin-shopping-center-selected-light'
export const SHOPPING_CENTER_SELECTED_PIN_DARK = 'pin-shopping-center-selected-dark'
// Mobility pins
export const MOBILITY_PIN_0 = 'pin-mobility-0'
export const MOBILITY_PIN_1 = 'pin-mobility-1'
export const MOBILITY_PIN_2 = 'pin-mobility-2'
export const MOBILITY_PIN_3 = 'pin-mobility-3'
export const MOBILITY_PIN_4 = 'pin-mobility-4'
export const MOBILITY_PIN_5 = 'pin-mobility-5'
export const MOBILITY_PIN_6 = 'pin-mobility-6'
export const MOBILITY_PIN_7 = 'pin-mobility-7'

// Owner reveal pins
export const RED_DOT_PIN = 'red-dot'

// Old pins
export const PINK_DOT_NAME = 'pink-dot'
export const GREEN_DOT_NAME = 'green-dot'
export const BLUE_DOT_NAME = 'blue-dot'

// base pin: can change color by setting icon-color paint property
export const PIN_BASE_NAME = 'pin-base'

export const POI_DOT_LAYER_ID = 'poi-circle-layer'
export const PINK_PIN_NAME = 'pink-pin'
export const BLUE_PIN_WITH_BB_NAME = 'blue-pin-with-billboard'
export const BLUE_PIN = 'blue-pin'
export const BIG_BLUE_PIN_NAME = 'big-blue-pin'
export const GREEN_PIN_SELECTED_NAME = 'green-pin-selected'
export const GREEN_PIN_NAME = 'green-pin'
export const GREEN_PIN_BASIC_NAME = 'green-pin-basic'
export const SELECTED_PIN_NAME = 'selected-pin'
export const TOP_PIN_NAME = 'top-pin'
export const MIDDLE_PIN_NAME = 'middle-pin'
export const BOTTOM_PIN_NAME = 'bottom-pin'
export const PHOTO_DIMENSION = 600
export const SHOPPING_CENTER_NAICS_CODE = '531120'

export const SHOPPING_CENTER_FILTER: Expression = ['==', ['get', 'naicsCode'], SHOPPING_CENTER_NAICS_CODE]
// these expressions color the POI pin blue if its a shopping center (based on naicsCode)
export const DOT_ICON_MATCH: Expression = [
  'match',
  ['get', 'naicsCode'],
  SHOPPING_CENTER_NAICS_CODE,
  BLUE_DOT_NAME,
  PINK_DOT_NAME,
]

// POI ICON MATCH
export const LIGHT_CATEGORY_ICON_MATCH: Expression = [
  'match',
  ['get', 'naicsCode'],
  POI_CATEGORIES_MAP.get('SHOPPING_CENTER'),
  SHOPPING_CENTER_PIN_LIGHT,
  POI_CATEGORIES_MAP.get('RETAIL'),
  RETAIL_PIN_LIGHT,
  POI_CATEGORIES_MAP.get('MEDICAL'),
  MEDICAL_PIN_LIGHT,
  POI_CATEGORIES_MAP.get('OFFICE'),
  OFFICE_PIN_LIGHT,
  POI_CATEGORIES_MAP.get('INDUSTRIAL'),
  INDUSTRIAL_PIN_LIGHT,
  POI_CATEGORIES_MAP.get('HOSPITALITY'),
  HOSPITALITY_PIN_LIGHT,
  POI_CATEGORIES_MAP.get('MULTIFAMILY'),
  MULTIFAMILY_PIN_LIGHT,
  POI_CATEGORIES_MAP.get('SINGLEFAMILY'),
  SINGLEFAMILY_PIN_LIGHT,
  // Fallback
  OTHER_PIN_LIGHT,
]
export const LIGHT_CATEGORY_ICON_ALT_MATCH: Expression = [
  'match',
  ['get', 'naicsCode'],
  POI_CATEGORIES_MAP.get('SHOPPING_CENTER'),
  SHOPPING_CENTER_PIN_LIGHT,
  POI_CATEGORIES_MAP.get('RETAIL'),
  RETAIL_PIN_ALT_LIGHT,
  POI_CATEGORIES_MAP.get('MEDICAL'),
  MEDICAL_PIN_ALT_LIGHT,
  POI_CATEGORIES_MAP.get('OFFICE'),
  OFFICE_PIN_ALT_LIGHT,
  POI_CATEGORIES_MAP.get('INDUSTRIAL'),
  INDUSTRIAL_PIN_ALT_LIGHT,
  POI_CATEGORIES_MAP.get('HOSPITALITY'),
  HOSPITALITY_PIN_ALT_LIGHT,
  POI_CATEGORIES_MAP.get('MULTIFAMILY'),
  MULTIFAMILY_PIN_ALT_LIGHT,
  POI_CATEGORIES_MAP.get('SINGLEFAMILY'),
  SINGLEFAMILY_PIN_ALT_LIGHT,
  // Fallback
  OTHER_PIN_ALT_LIGHT,
]
export const DARK_CATEGORY_ICON_MATCH: Expression = [
  'match',
  ['get', 'naicsCode'],
  POI_CATEGORIES_MAP.get('SHOPPING_CENTER'),
  SHOPPING_CENTER_PIN_DARK,
  POI_CATEGORIES_MAP.get('RETAIL'),
  RETAIL_PIN_DARK,
  POI_CATEGORIES_MAP.get('MEDICAL'),
  MEDICAL_PIN_DARK,
  POI_CATEGORIES_MAP.get('OFFICE'),
  OFFICE_PIN_DARK,
  POI_CATEGORIES_MAP.get('INDUSTRIAL'),
  INDUSTRIAL_PIN_DARK,
  POI_CATEGORIES_MAP.get('HOSPITALITY'),
  HOSPITALITY_PIN_DARK,
  POI_CATEGORIES_MAP.get('MULTIFAMILY'),
  MULTIFAMILY_PIN_DARK,
  POI_CATEGORIES_MAP.get('SINGLEFAMILY'),
  SINGLEFAMILY_PIN_DARK,
  // Fallback
  OTHER_PIN_DARK,
]
export const DARK_CATEGORY_ICON_ALT_MATCH: Expression = [
  'match',
  ['get', 'naicsCode'],
  POI_CATEGORIES_MAP.get('SHOPPING_CENTER'),
  SHOPPING_CENTER_PIN_DARK,
  POI_CATEGORIES_MAP.get('RETAIL'),
  RETAIL_PIN_ALT_DARK,
  POI_CATEGORIES_MAP.get('MEDICAL'),
  MEDICAL_PIN_ALT_DARK,
  POI_CATEGORIES_MAP.get('OFFICE'),
  OFFICE_PIN_ALT_DARK,
  POI_CATEGORIES_MAP.get('INDUSTRIAL'),
  INDUSTRIAL_PIN_ALT_DARK,
  POI_CATEGORIES_MAP.get('HOSPITALITY'),
  HOSPITALITY_PIN_ALT_DARK,
  POI_CATEGORIES_MAP.get('MULTIFAMILY'),
  MULTIFAMILY_PIN_ALT_DARK,
  POI_CATEGORIES_MAP.get('SINGLEFAMILY'),
  SINGLEFAMILY_PIN_ALT_DARK,
  // Fallback
  OTHER_PIN_ALT_DARK,
]

export const LIGHT_SELECTED_ICON_MATCH: Expression = [
  'match',
  ['get', 'naicsCode'],
  POI_CATEGORIES_MAP.get('SHOPPING_CENTER'),
  SHOPPING_CENTER_SELECTED_PIN_LIGHT,
  POI_CATEGORIES_MAP.get('RETAIL'),
  RETAIL_SELECTED_PIN_LIGHT,
  POI_CATEGORIES_MAP.get('MEDICAL'),
  MEDICAL_SELECTED_PIN_LIGHT,
  POI_CATEGORIES_MAP.get('OFFICE'),
  OFFICE_SELECTED_PIN_LIGHT,
  POI_CATEGORIES_MAP.get('INDUSTRIAL'),
  INDUSTRIAL_SELECTED_PIN_LIGHT,
  POI_CATEGORIES_MAP.get('HOSPITALITY'),
  HOSPITALITY_SELECTED_PIN_LIGHT,
  POI_CATEGORIES_MAP.get('MULTIFAMILY'),
  MULTIFAMILY_SELECTED_PIN_LIGHT,
  POI_CATEGORIES_MAP.get('SINGLEFAMILY'),
  SINGLEFAMILY_SELECTED_PIN_LIGHT,
  // Fallback
  OTHER_PIN_SELECTED_LIGHT,
]

export const DARK_SELECTED_ICON_MATCH: Expression = [
  'match',
  ['get', 'naicsCode'],
  POI_CATEGORIES_MAP.get('SHOPPING_CENTER'),
  SHOPPING_CENTER_SELECTED_PIN_DARK,
  POI_CATEGORIES_MAP.get('RETAIL'),
  RETAIL_SELECTED_PIN_DARK,
  POI_CATEGORIES_MAP.get('MEDICAL'),
  MEDICAL_SELECTED_PIN_DARK,
  POI_CATEGORIES_MAP.get('OFFICE'),
  OFFICE_SELECTED_PIN_DARK,
  POI_CATEGORIES_MAP.get('INDUSTRIAL'),
  INDUSTRIAL_SELECTED_PIN_DARK,
  POI_CATEGORIES_MAP.get('HOSPITALITY'),
  HOSPITALITY_SELECTED_PIN_DARK,
  POI_CATEGORIES_MAP.get('MULTIFAMILY'),
  MULTIFAMILY_SELECTED_PIN_DARK,
  POI_CATEGORIES_MAP.get('SINGLEFAMILY'),
  SINGLEFAMILY_SELECTED_PIN_DARK,
  // Fallback
  OTHER_PIN_SELECTED_DARK,
]

// POI Text Colors
export const RETAIL_TEXT_COLOR_LIGHT = 'rgba(53, 108, 252, 1)'
export const RETAIL_TEXT_COLOR_DARK = 'rgba(189, 212, 255, 1)'
export const OFFICE_TEXT_COLOR_LIGHT = 'rgba(0, 133, 109, 1)'
export const OFFICE_TEXT_COLOR_DARK = 'rgba(159, 251, 220, 1)'
export const MEDICAL_TEXT_COLOR_LIGHT = 'rgba(209, 45, 88, 1)'
export const MEDICAL_TEXT_COLOR_DARK = 'rgba(246, 171, 184, 1)'
export const INDUSTRIAL_TEXT_COLOR_LIGHT = 'rgba(83, 92, 103, 1)'
export const INDUSTRIAL_TEXT_COLOR_DARK = 'rgba(228, 231, 233, 1)'
export const MULTIFAMILY_TEXT_COLOR_LIGHT = 'rgba(198, 70, 8, 1)'
export const MULTIFAMILY_TEXT_COLOR_DARK = 'rgba(255, 239, 212, 1)'
export const SINGLEFAMILY_TEXT_COLOR_LIGHT = 'rgba(239, 96, 7, 1)'
export const SINGLEFAMILY_TEXT_COLOR_DARK = 'rgba(255, 218, 168, 1)'
export const HOSPITALITY_TEXT_COLOR_LIGHT = 'rgba(222, 36, 111, 1)'
export const HOSPITALITY_TEXT_COLOR_DARK = 'rgba(252, 206, 230, 1)'
export const OTHER_TEXT_COLOR_LIGHT = 'rgba(98, 110, 123, 1)'
export const OTHER_TEXT_COLOR_DARK = 'rgba(203, 209, 214, 1)'
export const SHOPPING_CENTER_TEXT_COLOR_LIGHT = 'rgba(31, 75, 241, 1)'
export const SHOPPING_CENTER_TEXT_COLOR_DARK = 'rgba(189, 212, 255, 1)'

export const LIGHT_POI_TEXT_MATCH: Expression = [
  'match',
  ['get', 'naicsCode'],
  POI_CATEGORIES_MAP.get('SHOPPING_CENTER'),
  SHOPPING_CENTER_TEXT_COLOR_LIGHT,
  POI_CATEGORIES_MAP.get('RETAIL'),
  RETAIL_TEXT_COLOR_LIGHT,
  POI_CATEGORIES_MAP.get('MEDICAL'),
  MEDICAL_TEXT_COLOR_LIGHT,
  POI_CATEGORIES_MAP.get('OFFICE'),
  OFFICE_TEXT_COLOR_LIGHT,
  POI_CATEGORIES_MAP.get('INDUSTRIAL'),
  INDUSTRIAL_TEXT_COLOR_LIGHT,
  POI_CATEGORIES_MAP.get('HOSPITALITY'),
  HOSPITALITY_TEXT_COLOR_LIGHT,
  POI_CATEGORIES_MAP.get('MULTIFAMILY'),
  MULTIFAMILY_TEXT_COLOR_LIGHT,
  POI_CATEGORIES_MAP.get('SINGLEFAMILY'),
  SINGLEFAMILY_TEXT_COLOR_LIGHT,
  // Fallback
  OTHER_TEXT_COLOR_LIGHT,
]

export const DARK_POI_TEXT_MATCH: Expression = [
  'match',
  ['get', 'naicsCode'],
  POI_CATEGORIES_MAP.get('SHOPPING_CENTER'),
  SHOPPING_CENTER_TEXT_COLOR_DARK,
  POI_CATEGORIES_MAP.get('RETAIL'),
  RETAIL_TEXT_COLOR_DARK,
  POI_CATEGORIES_MAP.get('MEDICAL'),
  MEDICAL_TEXT_COLOR_DARK,
  POI_CATEGORIES_MAP.get('OFFICE'),
  OFFICE_TEXT_COLOR_DARK,
  POI_CATEGORIES_MAP.get('INDUSTRIAL'),
  INDUSTRIAL_TEXT_COLOR_DARK,
  POI_CATEGORIES_MAP.get('HOSPITALITY'),
  HOSPITALITY_TEXT_COLOR_DARK,
  POI_CATEGORIES_MAP.get('MULTIFAMILY'),
  MULTIFAMILY_TEXT_COLOR_DARK,
  POI_CATEGORIES_MAP.get('SINGLEFAMILY'),
  SINGLEFAMILY_TEXT_COLOR_DARK,
  // Fallback
  OTHER_TEXT_COLOR_DARK,
]

const RETAIL_CATEGORY_COLOR = 'rgba(85, 143, 255, 1)'
const MEDICAL_CATEGORY_COLOR = 'rgba(230, 24, 89, 1)'
const OFFICE_CATEGORY_COLOR = 'rgba(0, 204, 159, 1)'
const INDUSTRIAL_CATEGORY_COLOR = 'rgba(98, 110, 123, 1)'
const HOSPITALITY_CATEGORY_COLOR = 'rgba(246, 112, 177, 1)'
const MULTIFAMILY_CATEGORY_COLOR = 'rgba(238, 244, 255, 1)'
const OTHER_CATEGORY_COLOR = 'rgba(167, 176, 185, 1)'

export const getCategoryColorFromCategory = (category: string) => {
  switch (category) {
    case 'Retail':
      return RETAIL_CATEGORY_COLOR
    case 'Medical':
      return MEDICAL_CATEGORY_COLOR
    case 'Office':
      return OFFICE_CATEGORY_COLOR
    case 'Industrial':
      return INDUSTRIAL_CATEGORY_COLOR
    case 'Hospitality':
      return HOSPITALITY_CATEGORY_COLOR
    case 'Multifamily':
      return MULTIFAMILY_CATEGORY_COLOR
    case 'Singlefamily':
      return SINGLEFAMILY_TEXT_COLOR_LIGHT
    case 'Shopping Center':
      return SHOPPING_CENTER_TEXT_COLOR_LIGHT
    default:
      return OTHER_CATEGORY_COLOR
  }
}

export const getCategoryFromNaicsCode = (naicsCode?: string) => {
  if (!naicsCode) {
    return { category: 'Other', color: OTHER_CATEGORY_COLOR }
  }
  for (const [category, codes] of POI_CATEGORIES_MAP.entries()) {
    if (codes.includes(naicsCode)) {
      switch (category) {
        case 'RETAIL':
          return { category: 'Retail', color: RETAIL_CATEGORY_COLOR }
        case 'MEDICAL':
          return { category: 'Medical', color: MEDICAL_CATEGORY_COLOR }
        case 'OFFICE':
          return { category: 'Office', color: OFFICE_CATEGORY_COLOR }
        case 'INDUSTRIAL':
          return { category: 'Industrial', color: INDUSTRIAL_CATEGORY_COLOR }
        case 'HOSPITALITY':
          return { category: 'Hospitality', color: HOSPITALITY_CATEGORY_COLOR }
        case 'MULTIFAMILY':
          return { category: 'Multifamily', color: MULTIFAMILY_CATEGORY_COLOR }
        case 'SINGLEFAMILY':
          return { category: 'Singlefamily', color: SINGLEFAMILY_TEXT_COLOR_LIGHT }
        case 'SHOPPING_CENTER':
          return { category: 'Shopping Center', color: SHOPPING_CENTER_TEXT_COLOR_LIGHT }
        default:
          return { category: 'Other', color: OTHER_CATEGORY_COLOR }
      }
    }
  }
  return { category: 'Other', color: OTHER_CATEGORY_COLOR }
}
